import { NBSP } from '../../../../constants/symbols';

export const SERVICE_DESCRIPTIONS: TStringObject = {
  top3: `Выше всех, большие фото и${NBSP}логотип агентства.`,
  'premium+highlight': `Ниже Топов, но${NBSP}выше Платных. Яркий жёлтый фон выделяет эти объявления в${NBSP}поиске.`,
  premium: `Ниже Топов, но${NBSP}выше Платных. Вы${NBSP}получите в${NBSP}2${NBSP}раза больше звонков по${NBSP}сравнению с${NBSP}Платными.`,
  'paid+highlight': `Ниже Топов и${NBSP}Премиумов. Жёлтый фон выделяет эти объявления в${NBSP}поиске.`,
  paid: `Ниже Топов и${NBSP}Премиумов, никак не${NBSP}выделяется в${NBSP}поиске.`,
  free: `Ниже всех, никак не${NBSP}выделяется в${NBSP}поиске.`,
};
